module.exports = __webpack_public_path__ + "static/media/platform-icons@2x.86f576bb.png";